module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n\r\n<div class=\"propTitle prop-header hide\"><span class=\"prop-label\">Ranking Settings</span></div>\r\n\r\n\r\n<table id=\"propMainTable\"></table>\r\n\r\n\r\n<div id=\"propMainGridButtons\" class=\"propMainGridButtons\">\r\n    <button type=\"button\" id=\"\" title=\"new\" name=\"itemNew\" class=\"itemNew btn btn-default hvr-glow tbl-icon\">\r\n        <i class=\"fa pf-add\" style=\"\"></i>\r\n    </button>\r\n    <button type=\"button\" id=\"\" title=\"remove\"  name=\"itemRemove\" class=\"itemRemove btn btn-default hvr-glow tbl-icon\">\r\n        <i class=\"fa pf-delete icon-gradient\"></i>\r\n    </button>\r\n    <button type=\"button\" id=\"\" name=\"itemUp\" title=\"up\" class=\"itemUp btn btn-default hvr-glow tbl-icon\">\r\n        <i class=\"fa pf-icon-up pf-carot-down\" aria-expanded=\"true\" style=\"-webkit-transform: rotate(-180deg);\"></i>\r\n    </button>\r\n    <button type=\"button\" id=\"\" name=\"itemDown\" title=\"down\"  class=\"itemDown btn btn-default hvr-glow tbl-icon\" >\r\n        <i class=\"fa pf-carot-down\" aria-expanded=\"true\" style=\"\"></i>\r\n    </button>\r\n\r\n    <button type=\"button\" title=\"Add Predefined List\"  name=\"itemList\" id=\"\" class=\"itemList btn btn-default hvr-glow tbl-icon-lst\" >\r\n        <span class=\"fa fa-list-ul\"></span>\r\n    </button>\r\n</div>")
  }
  return __output;

}